import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { AppCard, AppRemixIcon } from '@/layout/AppComponents';
import { Accordion } from 'react-bootstrap';
import ReactDOMServer from 'react-dom/server';
import BreadcrumbHandler from '../../../layout/components/breadcrumb/BreadcrumbHandler';
import Translator from '../../../layout/components/helpers/Translator';
import Sidebar from '../../../layout/Sidebar/Sidebar';
import AppLink from '../../../routing/helpers/AppLink';
import EmailNotificationSettings from '../../../layout/screenSpecifics/Modules/LegalCompliance/EmailNotifications/EmailNotificationSettings';

export default function LegalCompliancePlantConfigurationScreen() {
  const { moduleBridgeHex, plantHex } = useParams();
  const auth = useSelector((state) => state.auth);

  return (
    <div>
      <Sidebar>
        <img
          src={auth.user?.client?.logoUrl}
          className="img-fluid"
          alt={auth.user?.client?.name}
          title={auth.user?.client?.name}
        />
        <Accordion>
          <ul>
            <li>
              <AppLink
                path="user_module_legalCompliance_evaluation"
                params={{
                  moduleBridgeHex,
                  plantHex,
                  page: 0,
                  filterHex: 0,
                }}
                className="sidebar-element"
              >
                <AppRemixIcon
                  icon="arrow-go-back-line"
                  className="sidebar-icon"
                  noVariants
                />{' '}
                <span className="sb-title">
                  <Translator file="user" name="user.evaluation" />
                </span>
              </AppLink>
            </li>
          </ul>
        </Accordion>
      </Sidebar>
      <BreadcrumbHandler
        paths={[
          {
            name: ReactDOMServer.renderToString(
              <Translator file="module-legalCompliance" name="evaluation" />
            ),
            route: {
              name: 'user_module_legalCompliance_evaluation',
              params: {
                moduleBridgeHex,
                plantHex,
                page: 0,
                filterHex: 0,
              },
            },
          },
          {
            name: ReactDOMServer.renderToString(
              <Translator file="module-legalCompliance" name="settings" />
            ),
          },
        ]}
      />
      <div className="p-2">
        <AppCard
          header={ReactDOMServer.renderToString(
            <Translator
              file="module-legalCompliance"
              name="notifications.settings"
            />
          )}
        >
          <EmailNotificationSettings type="Plant" element={plantHex} />
        </AppCard>
      </div>
    </div>
  );
}
